<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14PQttR/images/cover.jpg?1684306107274" alt="This image is the cover for the book Old Charleston Originals"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Old Charleston Originals
      </h1>
      <p class="bookDescription body article font2">
        <p>Old Charleston Originals by prolific local author Margaret Eastman revives stories from the Holy City's incredible past. Preserved within these pages are tales from the swashbuckling early settlers, tales of the exclusive events thrown by Jockey Club, and the rise and fall of the maritime empire of George Alfred Trenholm, considered the inspiration for the legendary blockade runner Rhett Butler. Discover what caused a near massacre in the state house, how two determined Charleston ladies stopped a bulldozer, why a plantation home to be floated down the Cooper River and many more stories from Charleston's past.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margaret Middleton Rivers Eastman
      </h2>
      
      <p class="authorDescription body article">A native Charlestonian, Margaret (Peg) M.R. Eastman was a professional guide at Winterthur Museum in Delaware. She coauthored Hidden History of Old Charleston and authored Remembering Old Charleston. She is a freelance writer for the Charleston Mercury and has lectured on Charleston architecture.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1001240c